import { render, staticRenderFns } from "./TheStatsMain.vue?vue&type=template&id=578da1c2&"
import script from "./TheStatsMain.vue?vue&type=script&lang=js&"
export * from "./TheStatsMain.vue?vue&type=script&lang=js&"
import style0 from "./TheStatsMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports